export default __webpack_public_path__ + "static/media/dancing-script-latin-600.c022cd8e.woff";